import useAuthenticationLogout from 'app/ui/useAuthenticationLogout'
import { useEffect } from 'react'

function Logout() {
  const { logout } = useAuthenticationLogout()

  useEffect(() => {
    logout()
  }, [logout])

  return null
}

export default Logout
